
const com = {
  loginByAccount: "/auth/token/form",//登录地址
  wxlogin:"/auth/token/timedg",//正式环境下的登录
  getSharKData:"/activity/share/",//获取分享的信息{id}
  dgPlusLogin:"/auth/token/dgPlus",//东莞+登录
  signature:"/oss/aliyun/signature", //获取零食签名参数，
  uploadFile:"/oss/aliyun/uploadFile",//文件上传接口，
  deleteFile:"oss/aliyun/deleteFile/",//删除文件接口 需要传id
}

// 报名接口
const activity = {
  getActity: "/participate/detail/", //获取一个活动，拼接id
  batchCreate:'/participate/record/batch/create',//批量报名
  residueNum:"/participate/record/current/",//查找剩余人数
  getSignUp:'/participate/record/',//获取报名历史记录
  updateRecord:"/participate/record/update",//更新报名信息+activityId
  deleteRecord:"participate/record/delete",//取消报名
}

// 问答和问卷接口
const quiz = {
  getQuiInfo: "/quiz/detail/",//获取信息
  getQuestion: "/question/list/",//添加问题{activityId}
  getExamination: "/quiz/generate/",//根据id获取答卷
  postExamination: "/quiz/submit",//提交问卷、+activityId
  getResult:"/quiz/result/",//获取问答结果接口
  getHistory:"/quiz/paper/history/list/",//获取之前提交答卷
  updateSubmit:"/quiz/paper/history/update",//修改之前的答卷
  getAnalysis:"/quiz/paper/analysis/", //获取答案解析(get请求),
  preSubmit:"/quiz/pre-submit",//提交用户信息(post)
  validateUserInfo:"/quiz/pre-submit/validate/",//验证是否已经提交过个人信息,
  getRankData:"/quiz/rank",//获取排行榜的数据
  initAccess:"/stat/access/",//获取访问统计数据get
}

//投票接口
const vote = {
  searchVoteOption: "/vote/options",//手机端查找投票项目
  getGroup:"/vote/group/query/",//获取分组
  getVoteDetails: "/vote/detail/",//获取投票详情
  getVoteSummary:"/vote/stat/summary/",// 统计投票数、浏览器数、选项数 GET+ID
  getRankData:"/vote/rank",//获取排行榜的数据,
  getRankTime:"/vote/latest/",//获取排行榜的时间，
  participate:"/vote/option/participate",//批量投票
  newBatchSubmit:"/vote/batch/submit",//新批量提交接口
  //定制接口
  getListCommunity:"/h5/new-box/listCommunity", //获取镇和村的数据接口
  register:"/h5/new-box/register", //用户注册接口
  isRegister:"/h5/new-box/isRegister"//判断用户是否注册成功接口
}

//抽奖的接口
const lottery = {
  getLotteryById:"/lottery/",//通过id获取抽奖{id}
  getPrizeData:"/lottery/prize/",//获取奖品列表{id}
  getPanel:"/lottery/panel/",// 获取盘格"{activityId}/{type}"
  startLottery:"/lottery/execute/",// 获取抽奖的概率
  getLotteryNum:"/lottery/stat/remain/",//获取剩余可抽奖的数据
  checkValidate:"/lottery/validate/",//检查是否允许可以抽奖（psot加上抽奖的id）
  postContact:"/lottery/result/contact",//提交联系方式+activityId
  getPrizeRecord:"/lottery/result/current/",//post提交，获取历史提交记录数据,
  sendRedPack:"/lottery/redPack/send",//post发送红包接口,加{activityId}参数是活动id（非抽奖活动）
  getContact:"lottery/result/getContact/"
}

//舆情部门问答单独定制使用接口
const competition = {
  isRegister:"/H5competition/isRegister", //是否注册(get),
  register:"/H5competition/register",//用户注册(post),
  createQuestion:"/H5competition/question",//生成答卷(get),
  uploadAudio:"/H5competition/xxqgUploadAudio",//上传录音接口
  submitPaper:"/H5competition/submitPaper",//提交答卷
  getAnalysis:"/H5competition/question/",//获取答案解析(get)
  canDraw:"/H5competition/canDraw",//用户是否可以抽奖
  drawLottery:"/H5competition/draw",//抽奖Post
  submitAddess:"/H5competition/submitAddess",//填写邮寄地址
  getLotterys:"/H5competition/getLotterys",//获取中奖接口
  checkCompetitionNum:"/H5competition/checkCompetitionNum",//每日答题和经典朗诵校验是否有权限
  deleteFiles:"/oss/aliyun/deleteFiles",//批量删除多个文件
}

//舆情部门问答单独定制使用接口
const competitionVersion1 = {
  isRegister:"/competition/isRegister", //是否注册(get),
  register:"/competition/register",//用户注册(post),
  isSign:"/competition/isSign",//是否签到(get)
  sign:"/competition/sign",//用户签到(get),
  getPersonalRank: "/competition/rank/personal",//个人比赛排名(get)
  getGroupRank:"/competition/rank/group",//团体赛排名(get),
  createQuestion:"/competition/question",//生成答卷(get),
  submit:"/competition/submit",//提交答卷(post),
  getOrgList:"/competition/org/list",//获取用户组织列表
  getMonthlyInfo:"/competition/monthly/info",//获取用户月度竞赛情况
  myCompetition:"/competition/my",//我的参赛情况,
  getAnalysis:"/competition/paper/",//获取答案解析(get)
  drawLottery:"/competition/lottery/draw",//抽奖Post
  updateRegister:"/competition/register/update",//修改注册信息,
  getRecord:"/competition/draw/record",//获取用户中奖记录
}

//定制项目接口
const customized = {
  //spreadCreativity项目接口
  submitSuggest:"h5/bqw/yql/suggest",//提交建议
  submitRegister:"h5/bqw/yql/register",//提交报名
  //消防新春问答
  generateZc:"/zdyActivity/generateZc/", //生成答卷
  commitZcQuiz:"/zdyActivity/commitZcQuiz",//提交答案
  queryPrizes:"/zdyActivity/queryPrizes",// 中奖名单
  //美丽庭院
  getRoutes:"/tripRoute/getRoutes",//获取路线
  getTripTowns:"/tripRoute/getTripTowns",//获取镇街
  getTripCommunities:"/tripRoute/getTripCommunities",//获取社区
  getPoints:"/tripRoute/getPoints",//获取路线下的点位
  getPointDetail:"/tripRoute/getPointDetail/",//需要加id,获取点位详情
  getRouteDetail:"/tripRoute/getRouteDetail/",//获取路线详情
  getCheckSignUser:"/zdy/checkSignUser",//检查是否可以打卡
  getSignByLocation:"/zdy/signByLocation",//打卡接口
  getSignRecords:"/zdy/getSignRecords",//获取打卡记录
  checkLocation:"/zdy/checkLocation",//校验打卡位置
  checkCompanyUser:"/zdy/checkCompanyUser"//校验企业用户
}


export default {
  com,
  activity,
  vote,
  quiz,
  lottery,
  competition,
  customized,
  competitionVersion1
}
